module.exports = __webpack_public_path__ + "static/img/chanpinzhilianganquanjiance.37fc3cd2.png";